import { c as _c } from "react/compiler-runtime";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { companyMemberSelector } from "@store/members/members-selector";
import { useAppSelector } from "@store/store-helper";
import { getTeamByIdSelector } from "@store/teams/teams-selector";
import { grey, ListItemText, TeamIcon } from "@flat-ui";
import { getPrettyName, getUserInitials } from "@utils/user-utils";
import { UiUtils } from "@stellar/utils";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/** List item in bulk action dialog for members */
export function MemberListContent(t0) {
  const $ = _c(13);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.id) {
    t1 = companyMemberSelector(item.id);
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const companyMember = useAppSelector(t1);
  let t2;
  if ($[2] !== item.id) {
    t2 = getTeamByIdSelector(item.id);
    $[2] = item.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedTeam = useAppSelector(t2);
  if (!companyMember && !selectedTeam) {
    return null;
  }
  let t3;
  if ($[4] !== companyMember) {
    t3 = companyMember && !FaroCoreApiUtils.Member.isTeam(companyMember) ? <SphereAvatar shouldHideWhiteRim={true} src={companyMember.thumbnailUrl} initials={getUserInitials(companyMember)} /> : <SphereAvatar icon={<TeamIcon sx={{
      width: "18px",
      height: "18px"
    }} />} size="small" shouldHideWhiteRim={true} backgroundColor={grey[700]} />;
    $[4] = companyMember;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== companyMember || $[7] !== selectedTeam?.memberCount || $[8] !== selectedTeam?.name) {
    t4 = companyMember && !FaroCoreApiUtils.Member.isTeam(companyMember) ? <ListItemText primary={FaroCoreApiUtils.Member.isMemberActive(companyMember) ? <var>{getPrettyName(companyMember)}</var> : UiUtils.DASH} secondary={<var>{companyMember.email}</var>} /> : <ListItemText primary={<var>{selectedTeam?.name ?? ""}</var>} secondary={`${selectedTeam?.memberCount ?? 0} members`} />;
    $[6] = companyMember;
    $[7] = selectedTeam?.memberCount;
    $[8] = selectedTeam?.name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}